import * as React from 'react';

function SvgLock(props) {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 8.5v7h9v-7h-9zM5 7a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1V8a1 1 0 00-1-1H5z"
        fill={props.color}
      />
      <circle cx={10} cy={12} r={1} fill={props.color} />
      <path
        d="M6.75 5.5A2.25 2.25 0 019 3.25h2a2.25 2.25 0 012.25 2.25v2a.25.25 0 01-.25.25H7a.25.25 0 01-.25-.25v-2z"
        fill="none"
        stroke={props.color}
        strokeWidth={1.5}
      />
    </svg>
  );
}

export default SvgLock;
